import Vue from 'vue';
import ifdev from '../directives/ifdev';

function setup() {
    Vue.directive('ifdev', ifdev);
}

export default { setup };
